import { render, staticRenderFns } from "./AuthorAvatar.vue?vue&type=template&id=3e0bf5ce&scoped=true"
import script from "./AuthorAvatar.vue?vue&type=script&lang=js"
export * from "./AuthorAvatar.vue?vue&type=script&lang=js"
import style0 from "./AuthorAvatar.vue?vue&type=style&index=0&id=3e0bf5ce&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0bf5ce",
  null
  
)

export default component.exports